<template>
  <div class="dashboard-panel-info">
    <User :user="$auth.user() || {}" size="md lg-pc" @about="toProfile()" />
    <div class="actions">
      <btn-edit-profile type="" />
      <btn-log-out class="logout" />
    </div>
    <hr />
    <div class="hide-mobile info">
      <div class="date">{{ date }}</div>
      <div class="weekday">{{ weekday }}</div>
      <btn-log-out class="logout" />
      <a class="made-by" href="#" target="_blank">
        <img src="@/assets/icons/made-by-uprising.svg" alt="" />
        <span>Made by Uprising<br>{{ year }}</span>
      </a>
    </div>
    <MobileNavigation @change="$emit('change', $event)" :active="navActive" :elements="navElements" />
  </div>
</template>

<script>
import User from '@/components/profile/User'
import BtnEditProfile from '@/components/buttons/btn-edit-profile'
import BtnLogOut from '@/components/buttons/btn-log-out'
import moment from 'moment'
import { mapMutations } from 'vuex'
import MobileNavigation from '@/components/dashboard/MobileNavigation'

export default {
  name: 'PanelInfo',
  props: {
    navElements: Array,
    navActive: String,
  },
  components: { MobileNavigation, BtnLogOut, BtnEditProfile, User },
  computed: {
    date() {
      return moment().format('MMM DD')
    },
    weekday() {
      return moment().format('dddd')
    },
    year(){
      return moment().year();
    }
  },
  methods: {
    toProfile() {
      this.$router.push({ name: 'Profile' })
    },

    ...mapMutations(['openModal']),
  },
}
</script>

<style lang="scss">
.dashboard-panel-info {
  display: flex;
  flex-direction: column;
  background: $white;
  border-top: 1px solid #f0f0f0;
  box-shadow: 0px 4.49832px 21.367px rgba(0, 0, 0, 0.06);
  padding: 24px 45px 10px 39px;
  min-height: min-content;

  @include PC {
    height: 100vh;
    position: sticky;
    top: 0;
    width: 304px;
    padding: 46px 48px;
    border-radius: 11px 0 0 11px;
    margin-top: -95px;
  }

  .user-block {
    .name {
      font-family: 'Source Serif Pro', serif;
      font-style: normal;
      font-weight: 700;
      font-size: 16px;
      line-height: 117.5%;
      color: #474747;

      @include PC {
        text-align: center;
      }
    }

    .about {
      height: 3.115rem;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      cursor: pointer;
    }

    @include PC {
      text-align: center;

      .avatar {
        float: none;
        margin: 0 auto 24px;
        width: 132px;
        height: 132px;
      }

      .info {
        align-items: center;
      }

      .about {
        height: 4.725rem;
        -webkit-line-clamp: 3;
        clear: both;
      }
    }
  }

  .actions {
    display: flex;
    margin-top: 10px;

    button {
      @include PC {
        min-width: 153px;
        height: 44px;
      }
    }

    button:not(:last-child) {
      margin-right: 10px;
    }

    @include PC {
      justify-content: center;

      button:not(:last-child) {
        margin: 0;
      }

      .logout {
        display: none;
      }
    }
  }

  hr {
    margin: 34px -32px;

    @include mobile {
      display: none;
    }
  }

  > .info {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-grow: 1;

    .date {
      font-weight: 700;
      font-size: 15px;
      line-height: 20px;
    }

    .weekday {
      font-weight: 700;
      font-size: 12px;
      line-height: 147.5%;
      color: $dark;
      margin-bottom: 64px;
    }

    button.large {
      width: 161px;
      margin-bottom: 36px;
    }

    .made-by {
      display: flex;
      align-items: center;
      margin-top: auto;
      gap: 10px;

      font-weight: 700;
      font-size: 13px;
      line-height: 144%;
      letter-spacing: -0.04em;
      color: #CCD7E6;
    }
  }
}
</style>
